module.exports = __webpack_public_path__ + "static/media/press.305ab098.svg";